// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-26cCI","icon":"icon-2G8UX"};